export default {
    collectes: [],
    collecteEnChargement: false
}